import { useState, useCallback, useRef } from 'react';

export const usePullToRefresh = (onRefresh) => {
  const [refreshing, setRefreshing] = useState(false);
  const startY = useRef(0);
  const pulling = useRef(false);

  const handleRefresh = useCallback(async () => {
    if (refreshing) return;
    setRefreshing(true);
    try {
      await onRefresh();
    } finally {
      setRefreshing(false);
    }
  }, [onRefresh, refreshing]);

  const onTouchStart = useCallback((e) => {
    if (window.scrollY === 0) {
      startY.current = e.touches[0].clientY;
      pulling.current = true;
    }
  }, []);

  const onTouchEnd = useCallback((e) => {
    if (!pulling.current) return;
    pulling.current = false;
    const endY = e.changedTouches[0].clientY;
    const diff = endY - startY.current;
    if (diff > 80) {
      handleRefresh();
    }
  }, [handleRefresh]);

  return { refreshing, onTouchStart, onTouchEnd };
};

export const RefreshIndicator = ({ refreshing }) => {
  if (!refreshing) return null;
  return (
    <div className="flex items-center justify-center py-3 lg:hidden" data-testid="pull-refresh-indicator">
      <div className="flex items-center gap-2 text-sm text-blue-600">
        <div className="h-4 w-4 border-2 border-blue-600 border-t-transparent rounded-full animate-spin" />
        Refreshing...
      </div>
    </div>
  );
};
